import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Search from 'lucide-react/dist/esm/icons/search';
import ShoppingCart from 'lucide-react/dist/esm/icons/shopping-cart';
import Heart from 'lucide-react/dist/esm/icons/heart';
import User from 'lucide-react/dist/esm/icons/user';
import { categories } from '../mockData';
import './Header.css';

const Header = ({ cartCount }) => {
  const [searchOpen, setSearchOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <header className="header">
      <div className="header-container container">
        <nav className="nav-links">
          {categories.map((category) => (
            <Link key={category.slug} to={`/?category=${category.slug}`} className="nav-link">
              {category.name}
            </Link>
          ))}
        </nav>

        <Link to="/" className="logo">
          <span className="anton-font">STILLAUT</span>
        </Link>

        <div className="header-actions">
          <div className="header-actions-group header-actions-group--left">
            <button
              className="icon-button"
              onClick={() => setSearchOpen(!searchOpen)}
              aria-label="Search"
            >
              <Search size={20} />
            </button>
            <button className="icon-button" aria-label="Favorites">
              <Heart size={20} />
            </button>
          </div>
          <div className="header-actions-group header-actions-group--right">
            <button
              className="icon-button cart-button"
              onClick={() => navigate('/cart')}
              aria-label="Shopping cart"
            >
              <ShoppingCart size={20} />
              {cartCount > 0 && <span className="cart-badge">{cartCount}</span>}
            </button>
            <button className="icon-button user-button" aria-label="User account">
              <User size={20} />
            </button>
          </div>
        </div>
      </div>

      {searchOpen && (
        <div className="search-bar">
          <div className="container">
            <input
              type="text"
              placeholder="Search products..."
              className="search-input"
              autoFocus
            />
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
